import React from 'react';
import Loader from '../Loader/Loader';
import { MdClose } from 'react-icons/md';

export default function ModalDefault({ 
  isOpen, 
  closeModal, 
  title = "Modal Title", 
  loading = false, 
  children 
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 backdrop-blur-sm">
      {/* Backdrop with subtle blur effect */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
        onClick={closeModal}
        aria-hidden="true"
      />
      
      <div 
        className={`
          relative bg-white rounded-xl shadow-2xl 
          w-full max-w-2xl max-h-[90vh] overflow-y-auto
          transform transition-all duration-300 ease-in-out
        
          ${loading ? 'opacity-80' : 'opacity-100'}
        `}
      >

        <div className="sticky top-0 z-10 bg-[#1E5EFF] text-white px-6 py-4 border-b border-gray-100 rounded-t-xl flex justify-between items-center">
          <h2 className="text-xl font-semibold ">{title}</h2>
          <button
            onClick={closeModal}
            className="
              p-1 rounded-full text-gray-400 hover:text-gray-600 
              hover:bg-gray-100 transition-colors duration-200
              focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
            "
            aria-label="Close modal"
            title="Close"
          >
            <MdClose className="w-6 h-6" />
          </button>
        </div>

        {loading && (
          <div className="flex items-center justify-center p-8 min-h-[200px]">
            <Loader loading={true} />
          </div>
        )}

        <div className={`p-6 ${loading ? 'hidden' : 'block'}`}>
          {children}
        </div>


        <div className="sticky bottom-0 h-4 bg-gradient-to-t from-white to-transparent pointer-events-none" />
      </div>
    </div>
  );
}